import { capitalize } from 'lodash'
import moment from 'moment';

import { getInfo, TruncateWithTooltipFormatter } from "@Components/Grid/components/Table/formatters";
import appStore from '@Stores/app';

import { DATA_TYPE, DATE_MASK } from './utils'

export default function TypeFormatter({ info }) {
  const { row } = getInfo(info)
  const { meta, dataType } = row
  const { configuration } = meta || {}
  const { filters } = configuration || {}

  if (!dataType) {
    return '--'
  }

  let children = ""

  if (dataType === 'subscriptions') {
    children = `Contest: ${filters ? filters.contestId : '--'}`
  }

  if (dataType.endsWith('drilldown')) {
    children = filters.map(([key, value]) => {
      value = value.join(', ')

      if ([null, undefined, ''].includes(value)) value = 'N/A'

      if (['hour', 'day', 'month'].includes(key)) {
        const [date] = value.split(', ')
        value = moment.utc(date).tz(appStore.timezone).format(DATE_MASK[key])
      }

      return `${capitalize(key)}: ${value}`
    }).join(', ')
  }

  return <>
    <TruncateWithTooltipFormatter className='twy-text-base-accent' value={DATA_TYPE[dataType]} />
    <TruncateWithTooltipFormatter className='text-sm font-semibold twy-text-base-neutral uppercase mt-1' value={children} />
  </>
}
